var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNetintrestmargin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/wallet_arrow_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 17.5858L20.7071 16.2929C20.3166 15.9024 19.6834 15.9024 19.2929 16.2929L18 17.5858M20 22V16.5858",
    stroke: "#FFAB51",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 830",
    d: "M22 13V6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H15",
    stroke: "#FFAB51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 831",
    d: "M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V6H22V6Z",
    stroke: "#FFAB51",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 828",
    d: "M2 12L2 16L6 16C7.10457 16 8 15.1046 8 14V14C8 12.8954 7.10457 12 6 12L2 12Z",
    stroke: "#FFAB51",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNetintrestmargin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/netintrestmargin.3959e3c5241da59779eb1bf9fe32776a.svg";